import { Button, Tabs, styled } from '@material-ui/core';
import { COLORS } from 'shared/constants/COLORS';

export const TabContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
  position: 'relative',
  marginRight: -10,
}));

// export const TabHeader = styled(Tabs)(({ theme }) => ({
//   marginRight: 10,
//   minHeight: '70px',
//   '& .MuiTab-root': {
//     minWidth: '200px',
//     borderBottom: `2px solid ${COLORS.LIGHT_BORDER}`,
//     [theme.breakpoints.down('sm')]: {
//       minWidth: '133px',
//     },
//   },
//   '& .Mui-selected': {
//     borderBottom: '2px solid #3e8bff',
//   },
//   '& .PrivateTabIndicator-colorSecondary-2381': {
//     backgroundColor: 'none',
//   },
// }));

export const TabHeader = styled(Tabs)(({ theme }) => ({
  marginRight: 10,
  marginBottom: 10,
  '& .MuiTab-root': {
    minWidth: '200px',
    borderBottom: `2px solid ${COLORS.LIGHT_BORDER}`,
    [theme.breakpoints.down('sm')]: {
      minWidth: '133px',
    },
  },
  '& .MuiTabs-indicator': {
    backgroundColor: '#3e8bff',
  },
  '& .PrivateTabIndicator-colorSecondary-2381': {
    backgroundColor: 'none',
  },
}));

export const TabLabelCont = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '10px',
}));

export const ActiveTabContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  overflow: 'hidden',
}));

export const HideFilterButton = styled(Button)(({ theme }) => ({
  position: 'absolute',
  backgroundColor: 'transparent',
  right: 10,
  top: 5,
  border: `1px solid ${COLORS.PRIMARY}`,
  [theme.breakpoints.up(1920)]: {
    right: 25,
  },
}));
